import { memo } from 'react';
import { TableCell } from 'semantic-ui-react';
import { ExamDatesForLocationItem } from '../common/types';
import styled from '@emotion/styled';
import { Panel } from '../common/Panel';

interface MemoTableCellProps {
  cellData: ExamDatesForLocationItem;
  rowIndex: number;
  cellIndex: number;
  isEditable: boolean;
  onCellChange: (rowIndex: number, cellIndex: number, newValue: boolean) => void;
}

export const MemoTableCell: React.FC<MemoTableCellProps> = memo(
  ({ cellData, rowIndex, cellIndex, isEditable, onCellChange }) => {
    const handleChange = () => {
      onCellChange(rowIndex, cellIndex, !cellData.active);
    };

    return (
      <S.TableCell>
        <Panel date={cellData} onChange={() => handleChange()} isEditable={isEditable} />
      </S.TableCell>
    );
  }
);

const S = {
  TableCell: styled(TableCell)`
    padding: 10px;
    border-right: 1px solid rgba(34, 36, 38, 0.1);
    user-select: none;
    width: 80px;
    height: 56px;
  `,
};
